import { mstInterface } from 'api-interface/mst.interface';

export class MstSystemAdminModel implements mstInterface.systemAdmin.PupReq {

    /** メールアドレス */
    mail: string;
    
    /** 管理者名 */
    name: string;

    /** パスワード */
    pass: string;

    /** 削除FLG */
    del: boolean;
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/model/mst.systemAdmin.model.ts